
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getQaAreasByStatus",
      resolverType: "query",
      routePath: "/getQaAreasByStatus",
      httpMethod: "POST",
    });
  